import { getCampaignSets } from '@pt/api/user'
import { TrafficType } from '@pt/enums/insights'
import { PlatformType } from '@pt/views/pt-entry/common-setting/account-auth/config'

export const Mintegral = TrafficType.Mintegral
export const Unity = TrafficType.Unity
export const Applovin = TrafficType.Applovin
export const IronSource = TrafficType.IronSource
export const Xmp = PlatformType.Xmp

export const allowedPushChannel = [Mintegral, Unity, Applovin, IronSource]

export const IsPushableChannel = (cl: TrafficType): boolean => {
  return allowedPushChannel.includes(cl)
}

export type PushableChannel =
  | typeof Mintegral
  | typeof Unity
  | typeof Applovin
  | typeof IronSource
  | typeof Xmp

export type ChannelSelectItem = {
  label: string
  value: any
  children?: ChannelSelectItem[]
}
export type ChannelSelectValue = Array<{
  name: string
  id: PushableChannel
  values: Array<ChannelSelectItem>
}>

export interface ResStatus {
  audio: number
  image: number
  video: number
}

export const defaultResStatus: ResStatus = {
  audio: 1,
  image: 0,
  video: 0,
}

// eslint-disable-next-line no-undef
export type AppsType = Awaited<
  ReturnType<typeof getCampaignSets>
>['data']['data']['list']

export interface AppInfo {
  package_name: string
  platform: 'ios' | 'android'
}

export function fmtSize(bytes: number): string {
  const a = ['Byte', 'K', 'M']
  let i = 0
  if (Number(bytes) !== 0) {
    while (Number(bytes) > 0 && i < 2) {
      bytes /= 1024
      // eslint-disable-next-line no-plusplus
      i++
    }
    const sTemp = Number(bytes).toFixed(1) + a[i]
    return sTemp
  } else if (Number(bytes) === 0) {
    return '0Byte'
  }
  return '-'
}
